// extracted by mini-css-extract-plugin
module.exports = {"input":"FormDate_input__ZyxXG","inputSpan":"FormDate_inputSpan__GCDdq"};